import React, {  useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,

} from "@mui/material";
import {
  AddRounded,
  EditRounded,
  DeleteOutlineRounded,
  OpenInNewRounded,
  LinkRounded,
  ClearRounded,
  SaveRounded,
} from "@mui/icons-material";

// ---------------------------------------------------------------------------
// Links Panel
// ---------------------------------------------------------------------------

function useDialogState(initial = false) {
    const [open, setOpen] = useState(initial);
    const onOpen = () => setOpen(true);
    const onClose = () => setOpen(false);
    return { open, onOpen, onClose };
  }
export default function LinksPanel({projectId, links, onAdd, onUpdate, onDelete }) {
  const dispatch = useDispatch()
  
  
  const dlg = useDialogState();
  const [form, setForm] = useState({ project_id:projectId, id: "", title: "", url: "" });

  function startNew() {
    setForm({project_id:projectId, id: "", title: "", url: "" });
    dlg.onOpen();
  }
  function startEdit(link) {
    setForm(link);
    dlg.onOpen();
  }
  function submit() {
    const trimmed = { ...form,project_id:projectId, title: form.title.trim(), url: form.url.trim() };
    if (!trimmed.title || !trimmed.url) return;
    if (!/^https?:\/\//i.test(trimmed.url)) trimmed.url = `https://${trimmed.url}`;
    if (trimmed.id) onUpdate(trimmed); else onAdd(trimmed);
    dlg.onClose();
  }

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6">Links</Typography>
        <Button startIcon={<AddRounded />} variant="contained" onClick={startNew}>Add link</Button>
      </Stack>

      <Grid container spacing={2}>
        {links.map((l) => (
          <Grid size={{xs:12, md:6, lg:4}}  key={l.id}>
            <Card variant="outlined">
              <CardContent>
                <Stack direction="row" justifyContent="space-between" alignItems="start" spacing={1}>
                  <Stack spacing={0.5} sx={{ minWidth: 0 }}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <LinkRounded fontSize="small" />
                      <Typography variant="subtitle1" noWrap title={l.title}>{l.title}</Typography>
                    </Stack>
                    <Typography variant="body2" color="text.secondary" noWrap title={l.url}>
                      {l.url}
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                      <Chip size="small" label={new Date(l.createdAt).toLocaleString()} />
                    </Stack>
                  </Stack>
                  <Stack direction="row" spacing={0.5}>
                    <Tooltip title="Open">
                      <IconButton size="small" component="a" href={l.url} target="_blank" rel="noreferrer">
                        <OpenInNewRounded fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit">
                      <IconButton size="small" onClick={() => startEdit({...l, project_id:projectId})}>
                        <EditRounded fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton size="small" onClick={() => onDelete({...l, project_id:projectId})}>
                        <DeleteOutlineRounded fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog open={dlg.open} onClose={dlg.onClose} fullWidth maxWidth="sm">
        <DialogTitle>{form.id ? "Edit link" : "Add link"}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField label="Title" value={form.title} onChange={(e) => setForm({ ...form, project_id:projectId,title: e.target.value })} autoFocus/>
            <TextField label="URL" value={form.url} onChange={(e) => setForm({ ...form, project_id:projectId, url: e.target.value })} placeholder="https://…"/>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button startIcon={<ClearRounded />} onClick={dlg.onClose}>Cancel</Button>
          <Button startIcon={<SaveRounded />} variant="contained" onClick={submit}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
